<template>
    <div class="main-layout__container">
        <div class="content__header content__header--one-item-per-line">
            <div class="content-header__back">
                <UIBackButton
                    :text="'К списку холдингов'"
                    :to="router.resolve({ name: 'HandbookHoldings' }).href"
                />
            </div>

            <div class="content-header__title">Добавление холдинга</div>

            <div class="content-header__background content-header__background--add-edit-page"></div>
        </div>

        <div class="content__body">
            <div class="form__content">
                <div class="form__fields">
                    <div class="form__field-group form__field-group--by-2">
                        <UIInput
                            id="holdingName"
                            v-model="form.name"
                            label="Название холдинга*"
                            :error-message="errors?.name?.join() ?? ''"
                        />

                        <UIInput
                            id="holdingSapCode"
                            v-model="form.sap_code"
                            label="SAP-код холдинга*"
                            :error-message="errors?.sap_code?.join() ?? ''"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="content__footer">
            <div class="form__actions">
                <UISimpleButton
                    button-type="outlined"
                    @clicked="goToHoldingsPage"
                >
                    Выйти без сохранения
                </UISimpleButton>

                <UISimpleButton
                    :loading="saveLoading"
                    @clicked="saveHolding"
                >
                    Сохранить
                </UISimpleButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';

    import { HoldingCreateForm, HoldingCreateFormErrors } from '@/types/holding.type.ts';

    import useHoldingRepository from '@/repositories/holding/useHoldingRepository.ts';
    import useNotifications from '@/utils/useNotifications.ts';

    import UIBackButton from '@/components/ui/UIBackButton/UIBackButton.vue';
    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const router = useRouter();
    const { createHolding } = useHoldingRepository();
    const { showSuccess } = useNotifications();

    const form = ref<HoldingCreateForm>({
        name: '',
        sap_code: '',
    });
    const saveLoading = ref<boolean>(false);
    const errors = ref<HoldingCreateFormErrors | null>(null);

    function saveHolding(): void {
        saveLoading.value = true;
        errors.value = null;

        createHolding(mapCreatedHoldingFromForm())
            .then(() => {
                showSuccess({
                    title: 'Холдинг добавлен',
                });

                goToHoldingsPage();
            })
            .catch((createHoldingErrors: HoldingCreateFormErrors) => {
                errors.value = createHoldingErrors;
            })
            .finally(() => {
                saveLoading.value = false;
            });
    }

    function mapCreatedHoldingFromForm(): HoldingCreateForm {
        return {
            name: form.value.name,
            sap_code: form.value.sap_code,
        };
    }

    function goToHoldingsPage(): void {
        router.push({ name: 'HandbookHoldings' });
    }
</script>
